import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Title, WrapperElement, Element, Icon, TitleElement, TextElement } from './styles';

const AdditionalInfo = ({ device }) => {
  const { t } = useTranslation();
  const ElementLabels = ['Exclusiveness', 'HighExposure', 'BestConversion'];

  return (
    <Container device={device} data-panel='landingZD-additionalInfo'>
      <Title device={device} data-panel='landingZD-additionalInfo-title'>
        {t('panel.landing_ZD.additionalInfo.titleSection')}
      </Title>
      <WrapperElement device={device}>
        {ElementLabels.map((element, i) => {
          return (
            <Element device={device} data-panel='landingZD-additionalInfo-cardContainer' key={i.toString()}>
              <Icon device={device} iconKey={element} data-panel={`landingZD-additionalInfo-icon-${element}`} />
              <div className='info'>
                <TitleElement data-panel={`landingZD-additionalInfo-sectionTitle-${element}`}>
                  {t(`panel.landing_ZD.additionalInfo.title.${element}`)}
                </TitleElement>
                <TextElement device={device} data-panel={`landingZD-additionalInfo-text-${element}`}>
                  {t(`panel.landing_ZD.additionalInfo.text.${element}`)}
                </TextElement>
              </div>
            </Element>
          );
        })}
      </WrapperElement>
    </Container>
  );
};

export default AdditionalInfo;
